import { Button as BaseButton, theme } from '@acorns/grove'
import Markdown from 'react-markdown'
import styled, { css } from 'styled-components'

export const FooterMarkdownText = styled(Markdown as any)`
  > p,
  a {
    color: ${theme.colors.primaryStone};
    font-size: 12px;
    line-height: 16px;
    margin: 0;
  }
`

export const Button = styled(BaseButton)`
  padding-left: 20px;
  padding-right: 20px;
`

export const whiteIconStyle = css`
  path {
    fill: ${theme.colors.primaryWhite};
  }
`
